import { defineFcm } from '../shared/factory';

export const FCM_PETITION_PAGE_TOP_SUPPORTERS = defineFcm('petition_page_top_supporters')
	.asBoolean()
	.withDefault(false)
	.toConfig();
